import axios from "../../utils/axios";

async function fetch(id) {
  return await axios.get(`/users/${id}/profile`);
}

async function update(data, id) {
  return await axios.patch(`/users/${id}/profile`, data);
}

async function markRead() {
  return await axios.post(`/notifications/mark-read`);
}

export const profileService = {
  fetch,
  update,
  markRead,
};
